export default __webpack_public_path__ + "static/time-8b9f6996cea7455b5623b61e4482262a.svg";